// extracted by mini-css-extract-plugin
module.exports = {"component":"flight-selector-card-list_component__VuIdy","button":"flight-selector-card-list_button___zxou"};